import { httpService } from '../../../http-service/httpService';
import { flattenObject } from '../../../utils/utils';
import {
  axiosTimeoutConfig,
  CERT_DETAILS_COL_PICKER_LOADING,
  CERT_DETAILS_LISTS_ERROR,
  SET_CERT_DETAILS_CERT_KEY,
  SET_CERT_DETAILS_COLUMN_PICKER_LIST,
  SET_CERT_DETAILS_FLATTENED_COLUMN_PICKER_LIST,
  SET_CERT_DETAILS_VIEW_CAMPAIGN_KEY,
  SET_CERT_DETAILS_VIEW_CERT_AUDITOR,
  SET_CERT_DETAILS_VIEW_CERT_NAME,
  SET_CERT_DETAILS_VIEW_ROWS_LIST,
  SET_CERT_GLOBAL_DATE_FORMAT,
  SET_CERT_OBJECT_FOR_REDIRECT,
  SET_CERTS_TIME_ZONE,
  SET_TOUCH_DEVICE_STATUS,
  UPDATE_SCREEN_SIZE,
} from '../types';
import { URL_COLUMN_PICKER_API } from '../urls';

export const updateScreenSize = (newLabel) => (dispatch, getState) => {
  const currentLabel =
    getState().certifications.details.global?.mediaQueryValue;

  if (newLabel !== currentLabel)
    dispatch({
      type: UPDATE_SCREEN_SIZE,
      payload: newLabel,
    });
};

export const updateTouchDevice = (state) => (dispatch) => {
  dispatch({
    type: SET_TOUCH_DEVICE_STATUS,
    payload: state,
  });
};

export const setGlobalDateFormat = (dateFormat) => (dispatch) => {
  dispatch({
    type: SET_CERT_GLOBAL_DATE_FORMAT,
    payload: dateFormat,
  });
};

export const setCertsTimeZone = (zone) => (dispatch) => {
  dispatch({
    type: SET_CERTS_TIME_ZONE,
    payload: zone,
  });
};

export const setCertKeyInUI = (certKey) => (dispatch) => {
  dispatch({
    type: SET_CERT_DETAILS_CERT_KEY,
    payload: certKey,
  });
};

export const setBackNavigationConfig = (config) => (dispatch) => {
  dispatch({
    type: SET_CERT_OBJECT_FOR_REDIRECT,
    payload: config,
  });
};

export const setCampaignKey = (campaignKey) => (dispatch) => {
  dispatch({
    type: SET_CERT_DETAILS_VIEW_CAMPAIGN_KEY,
    payload: campaignKey,
  });
};

export const setIsAuditor = (isAuditor) => (dispatch) => {
  dispatch({
    type: SET_CERT_DETAILS_VIEW_CERT_AUDITOR,
    payload: isAuditor,
  });
};

export const setCertificationName = (certificationName) => (dispatch) => {
  dispatch({
    type: SET_CERT_DETAILS_VIEW_CERT_NAME,
    payload: certificationName,
  });
};

export const setAllowedRows = (rowsList) => (dispatch) => {
  dispatch({
    type: SET_CERT_DETAILS_VIEW_ROWS_LIST,
    payload: rowsList,
  });
};

export const setCommonError =
  ({ isError, error }) =>
  (dispatch) => {
    dispatch({
      type: CERT_DETAILS_LISTS_ERROR,
      payload: { isError, error },
    });
  };

export const getColumnPickerListDetails =
  (campaignKey, certkey) => async (dispatch) => {
    const body = { campaignKey, certkey };

    dispatch({ type: CERT_DETAILS_COL_PICKER_LOADING, payload: true });
    dispatch({
      type: CERT_DETAILS_LISTS_ERROR,
      payload: { isError: false, error: null },
    });

    try {
      const { data } = await httpService.post(
        URL_COLUMN_PICKER_API,
        body,
        axiosTimeoutConfig
      );
      const { resultsList } = data;
      const flattenedPickerList = flattenObject(resultsList);

      dispatch({
        type: SET_CERT_DETAILS_COLUMN_PICKER_LIST,
        payload: resultsList,
      });
      dispatch({
        type: SET_CERT_DETAILS_FLATTENED_COLUMN_PICKER_LIST,
        payload: flattenedPickerList,
      });

      // return flattenedPickerList so callers can derive columnNames without waiting for a re-render
      return flattenedPickerList;
    } catch (error) {
      dispatch({ type: CERT_DETAILS_COL_PICKER_LOADING, payload: false });
      dispatch({
        type: CERT_DETAILS_LISTS_ERROR,
        payload: { isError: true, error: 'Failed to fetch columns' },
      });

      return null;
    } finally {
      dispatch({ type: CERT_DETAILS_COL_PICKER_LOADING, payload: false });
    }
  };
